// This is used for the jewelry grid webpack entry point to reduce bundle size and improve speed

import CarouselGrid from "../bundles/Wishlist/components/CarouselGrid";
import DisplayNotification from "../bundles/DisplayNotification/DisplayNotification";
import EmailFooterCapture from "../bundles/Site/components/EmailFooterCapture";
import EmailSmsCapture from "../bundles/Site/components/EmailSmsCapture";
import GridContainer from "../bundles/Rocksbox/components/GridContainer";
import PromoCodeBanner from "../bundles/Site/components/PromoCodeBanner";
import ReactOnRails from "react-on-rails";
import SearchContainer from "../bundles/Search/SearchContainer";

// Register React components used in Rails views
ReactOnRails.register({
  CarouselGrid,
  DisplayNotification,
  EmailFooterCapture,
  EmailSmsCapture,
  GridContainer,
  PromoCodeBanner,
  SearchContainer
});
